import './_tabs.scss'
import swipe from '../swiper-slider/swiper-slider'

const activeClass = 'active--runtime'

const tabs = el => {
  const allowClose = 'allowClose' in el.dataset
  const currentOpenedFilter = el.querySelector('[name="current_opened_filter"]')

  const toggleTab = (btn, isActive) => {
    const decor = btn.querySelector('[data-tabs-decor]')
    const content = el.querySelector(
      `[data-tab-content="${btn.dataset.tabsElement}"]`
    )

    btn.classList.toggle(activeClass, isActive)
    btn.classList.toggle('cursor-default', isActive && !allowClose)
    if (decor) {
      decor.style.visibility = isActive ? 'visible' : 'hidden'
    }
    if (content) {
      content.classList.toggle('visible', isActive)
      if (isActive) {
        swipe(content)
      }
    }
  }

  el.querySelectorAll('[data-tabs-element]').forEach(tab => {
    tab.addEventListener('click', e => {
      e.preventDefault()
      if (tab.classList.contains(activeClass) && allowClose) {
        toggleTab(tab, false)
        if (currentOpenedFilter) {
          currentOpenedFilter.value = ''
        }
      } else {
        const currentActiveTab = el.querySelector(
          `[data-tabs-element].${activeClass}`
        )
        if (currentActiveTab) {
          toggleTab(currentActiveTab, false)
        }
        toggleTab(tab, true)
        if (currentOpenedFilter) {
          currentOpenedFilter.value = tab.dataset.tabsElement
        }
      }
    })
  })

  const defaultOpenedTab = el.querySelector('[data-tabs-element].active')
  if (defaultOpenedTab) {
    defaultOpenedTab.click()
  }
}

const findAndInitTabs = container => {
  const tabsContainers = container.querySelectorAll('[data-tabs-container]')
  tabsContainers.forEach(tabsContainer => {
    if (!('initialized' in tabsContainer.dataset)) {
      tabsContainer.dataset.initialized = ''
      tabs(tabsContainer)
    }
  })
}

export default findAndInitTabs

if ('jQuery' in window) {
  window.jQuery(document).ajaxComplete(() => {
    findAndInitTabs(document.body)
  })
}
